import { Component } from '@angular/core';

@Component({
  selector: 'app-remove-offer-dialog',
  templateUrl: 'remove-offer-dialog.component.html'
})
export class RemoveOfferDialogComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/offers/campaigns/remove-offer-dialog/remove-offer-dialog.component.ts